export default "__VITE_ASSET__sP1cI$nL__"